package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository

class CheckGenerateChunkUseCase(
    private val answerFileRepository: AnswerFileRepository
) {
    suspend operator fun invoke(fileId: String): Result<Boolean> {
        return answerFileRepository.checkGeneratedChunk(fileId)
    }
}
